import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/bootstrap.css';
import './assets/css/index.css';
import './assets/css/form.css';
import {BrowserRouter} from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';
import {applyMiddleware, compose, createStore} from 'redux';
import {apiMiddleware} from 'redux-api-middleware';
import reducers from './reducers';
import thunk from 'redux-thunk'; //Thunk middleware for Redux
import {Provider} from 'react-redux';
import Routes from './routes';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

/**
 * Out of the box, the Redux store can only support the synchronous flow of data.
 * Using middleware like thunk helps support asynchronicity in a Redux application.
 * You can think of thunk as a wrapper for the store’s dispatch() method; rather than returning action objects,
 * we can use thunk action creators to dispatch functions or Promises.
 * Note that without thunks, synchronous dispatches are the default.
 */
const store = createStore(
    reducers,
    composeEnhancers(
        applyMiddleware(apiMiddleware, thunk)
    )
);

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <Routes/>
        </BrowserRouter>
    </Provider>, document.getElementById('root'));
//registerServiceWorker();